module.exports = __webpack_public_path__ + "static/media/arcane-eye.7c433199.svg";